import { Member } from 'modules/stream/domain/interfaces/game-info/gameInfoMapped';
import { TeamPlayerAvatar } from 'modules/teams/ui/components/team-card/styles';
import UDText from '../../../../ud-ui/components/text';
import { NumberWrapper } from './styles';
import { USER_DEFAULT_AVATAR } from 'shared/constants/links';

interface IProps {
  player: Member;
}

function PlayerItem(props: IProps) {
  const { player } = props;

  return (
    <div className={'align-items-center flex-row gap-2'}>
      <TeamPlayerAvatar url={player.photo ?? USER_DEFAULT_AVATAR} size={32} />
      <NumberWrapper backgroundColor={'#2D2D47'}>
        <UDText color={'white'} type={'subhead'}>
          {player.number}
        </UDText>
      </NumberWrapper>
      <div className={'flex-grow-1 flex-row gap-1'}>
        <UDText color={'white'} type={'subhead'}>
          {player.surname}
        </UDText>
        <UDText color={'white'} type={'subhead'}>
          {player.name}
        </UDText>
        <UDText color={'white'} type={'subhead'}>
          {player.middleName}
        </UDText>
      </div>
      <NumberWrapper backgroundColor={'#9093AA'}>
        <UDText color={'white'} type={'subhead'}>
          {player.qtyGoalsMatch}
        </UDText>
      </NumberWrapper>
      <NumberWrapper backgroundColor={'#D9B244'}>
        <UDText color={'white'} type={'subhead'}>
          {player.qtyYellowCardsMatch}
        </UDText>
      </NumberWrapper>
      <NumberWrapper backgroundColor={'#AB138A'}>
        <UDText color={'white'} type={'subhead'}>
          {player.qtyRedCardsMatch}
        </UDText>
      </NumberWrapper>
    </div>
  );
}

export default PlayerItem;
